var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head_know_module"},_vm._l((_vm.knowModule),function(pItem,index){return _c('div',{key:index,staticClass:"know_item",on:{"click":function($event){return _vm.headProLink(index)}}},[_c('span',[_vm._v(_vm._s(pItem.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c50409e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/views/header/knowledge.vue
// module id = null
// module chunks = 